import classNames from 'classnames';

import styles from './PageWidth.module.css';

import type { BreakpointSize } from '../../styles';

type IntrinsicDivProps = JSX.IntrinsicElements['div'];

export interface PageWidthProps extends IntrinsicDivProps {
  /** Toggle max width */
  enabled?: boolean;
  /**
   * Breakpoints to skip, as skipped breakpoint will use the next lowest
   * unskipped breakpoint value
   */
  skip?: BreakpointSize[];
}

/**
 * Reduce the content to a max width, centered in the viewport.
 *
 * @cssVariable --page-margin-xs The page width margin at the XS breakpoint
 * @cssVariable --page-margin-sm The page width margin at the SM breakpoint
 * @cssVariable --page-margin-md The page width margin at the MD breakpoint
 * @cssVariable --page-margin-lg The page width margin at the LG breakpoint
 * @cssVariable --page-margin-xl The page width margin at the XL breakpoint
 * @see https://corgi-x.tfd.engineering/components/pagewidth
 */
export function PageWidth({
  children,
  enabled = true,
  skip = [],
  className,
  ...props
}: PageWidthProps) {
  return (
    <div
      className={classNames(
        styles.container,
        { [styles.disabled]: !enabled },
        ...skip.map(s => styles[`skip-${s}`]),
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
